/**
 * Centralized utility for administrative level labels
 * Gets labels from country configuration
 */

import { getCountryConfig } from '../config/countries';

/**
 * Get human-readable label for an administrative level
 * @param level - The administrative level number (0-4)
 * @param countryCode - Country code (default: 'ZW')
 * @returns Human-readable label (e.g., 'Province', 'District', 'Ward')
 */
export function getAdministrativeLevelLabel(level: number, countryCode: string = 'ZW'): string {
  const config = getCountryConfig(countryCode);
  
  if (!config) {
    return `Level ${level}`;
  }
  
  const levelConfig = config.administrativeLevels.find(l => l.level === level);
  return levelConfig?.name || `Level ${level}`;
}

/**
 * Get all administrative level labels as a map for a country
 * @param countryCode - Country code (default: 'ZW')
 * @returns Record mapping level numbers to labels
 */
export function getAdministrativeLevelLabels(countryCode: string = 'ZW'): Record<string, string> {
  const config = getCountryConfig(countryCode);
  
  if (!config) {
    return {
      '0': 'Country',
      '1': 'Province',
      '2': 'District',
      '3': 'Ward',
      '4': 'Village'
    };
  }
  
  const labels: Record<string, string> = {};
  config.administrativeLevels.forEach(level => {
    labels[level.level.toString()] = level.name;
  });
  
  return labels;
}

